import React from "react";
import {
  FiEye,
  FiMessageSquare,
  FiTrash2,
  FiMapPin,
  FiImage,
  FiBriefcase,
} from "react-icons/fi";
import { formatCurrency, formatDate, resolveAssetUrl } from "../utils/formatters";
import "./PostTableView.css";

const PostTableView = ({
  posts = [],
  onViewDetails,
  onOpenComments,
  onDelete,
  canDelete = false,
}) => {
  if (posts.length === 0) {
    return null;
  }

  return (
    <div className="shared-post-table-wrap">
      <table className="shared-post-table">
        <thead>
          <tr>
            <th>Post / Requirement</th>
            <th>Service</th>
            <th>Property Type</th>
            <th>Budget</th>
            <th>Location</th>
            <th>Posted By</th>
            <th>Date</th>
            <th className="shared-post-table__actions-head">Actions</th>
          </tr>
        </thead>
        <tbody>
          {posts.map((post) => {
            const imagesList = Array.isArray(post.images) ? post.images : [];
            const firstImg = imagesList.length > 0 ? imagesList[0] : null;
            const imgUrl = firstImg?.image_url || firstImg?.imagePath || firstImg?.url;
            const resolvedImg = imgUrl ? resolveAssetUrl(imgUrl) : null;

            const propertyTypeName =
              typeof post.property_type === "object"
                ? post.property_type?.name
                : post.property_type || "N/A";

            const creatorName =
              post.customer?.first_name || post.partner?.first_name || post.user?.first_name || post.customer_name
                ? `${post.customer?.first_name || post.partner?.first_name || post.user?.first_name || post.customer_name} ${
                    post.customer?.last_name || post.partner?.last_name || post.user?.last_name || ""
                  }`.trim()
                : "User";

            const formattedBudget = formatCurrency(post.budget) || "Not Specified";
            const postDate = post.created_on || post.created_at;

            return (
              <tr key={post.id}>
                <td>
                  <div className="shared-post-table__project-cell">
                    <div
                      className="shared-post-table__thumb"
                      onClick={() => onViewDetails(post)}
                    >
                      {resolvedImg ? (
                        <img
                          src={resolvedImg}
                          alt={post.service}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <FiImage className="shared-post-table__thumb-placeholder" />
                      )}
                    </div>
                    <div className="shared-post-table__project-info">
                      <span
                        className="shared-post-table__project-name"
                        onClick={() => onViewDetails(post)}
                      >
                        {post.service ? `${post.service} Request` : `Post #${post.id}`}
                      </span>
                      {post.area_name && (
                        <span className="shared-post-table__project-sub">
                          {post.area_name}
                        </span>
                      )}
                    </div>
                  </div>
                </td>

                <td>
                  <span className="shared-post-table__service-badge">
                    <FiBriefcase size={12} />
                    <span>{post.service || "General"}</span>
                  </span>
                </td>

                <td>
                  <span className="shared-post-table__type-badge">
                    {propertyTypeName}
                  </span>
                </td>

                <td>
                  <span className="shared-post-table__budget">
                    {formattedBudget}
                  </span>
                </td>

                <td>
                  <div className="shared-post-table__location-cell">
                    <FiMapPin size={13} className="text-danger" />
                    <span>
                      {[post.city_name, post.state_name].filter(Boolean).join(", ") ||
                        "N/A"}
                    </span>
                  </div>
                </td>

                <td>
                  <span className="shared-post-table__creator-name">
                    {creatorName}
                  </span>
                </td>

                <td>
                  <span className="shared-post-table__date">
                    {formatDate(postDate)}
                  </span>
                </td>

                <td>
                  <div className="shared-post-table__actions">
                    <button
                      type="button"
                      className="shared-post-table__action-btn shared-post-table__action-btn--primary"
                      onClick={() => onViewDetails(post)}
                      title="View Details"
                    >
                      <FiEye size={15} />
                    </button>

                    <button
                      type="button"
                      className="shared-post-table__action-btn shared-post-table__action-btn--secondary"
                      onClick={() => onOpenComments(post)}
                      title="Discussion"
                    >
                      <FiMessageSquare size={15} />
                    </button>

                    {canDelete && (
                      <button
                        type="button"
                        className="shared-post-table__action-btn shared-post-table__action-btn--danger"
                        onClick={() => onDelete(post)}
                        title="Delete Post"
                      >
                        <FiTrash2 size={15} />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PostTableView;
